import React, { useEffect } from "react";
import Cookies from "universal-cookie";
import logo from "../../assets/img/bravaslogo.png";
import logoIcon from "../../assets/img/bravas_icon.png";
import Image from "../Image/Image";
import "./Logo.css";

function Logo(props) {
	const loadLogo = (imgId, isLogin) => {
		const cookies = new Cookies();
		if (!isLogin) {
			cookies.remove("LOGO_COOKIE", { path: "/login" });

			if (imgId) {
				cookies.set("LOGO_COOKIE", imgId);
			} else {
				cookies.set("LOGO_COOKIE", logo);
			}
		}
	};

	useEffect(() => {
		loadLogo(props.imgId, props.isLogin);
	}, [props.imgId, props.isLogin]);

	return (
		<Image
			cached={false}
			cacheKey={`organization-logo`}
			imgId={props.imgId}
			alt={props.alt}
			className={props.className}
			defaultImage={props.showIcon ? logoIcon : logo}
			isLogo={true}
		/>
	);
}

export default Logo;
